import React from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import { Route, Redirect } from 'react-router-dom';
import { UserContext } from '../consts';
import Footer from '../containers/global/Footer';
import HeaderDrawer from '../containers/global/HeaderDrawer/HeaderDrawer';
import { ThemeContext } from '../contexts/ThemeContext';
import LoadAssistent from './LoadAssistant';
import SesiSupportBtn from './SesiSupport';
import WhatsappSupport from './WhatsappSupport'

const PrivateRoute = ({
  navbar,
  footer,
  permission,
  allowedGroups,
  component: Component,
  ...rest
}) => (
  <div>
    <Route
      {...rest}
      render={(props) =>
        localStorage.getItem('token') ? (
          <UserContext.Consumer>
            {(context) => {
              if (
                get(context, 'groups.perfil.value') !== undefined &&
                !allowedGroups.includes(get(context, 'groups.perfil.value'))
              ) {
                if (get(context, `user.permissions.${permission}`) !== true) {
                  return <Redirect to="/escolher-instituicao" />;
                }
              }
              const host = window.location.host;
              const href = window.location.href;
              const iframe = JSON.parse(localStorage.getItem('iframe'));

              return (
                <React.Fragment>
                  {(navbar && !iframe) && <HeaderDrawer {...context} />}
                  <div style={{ marginBottom: '5.5rem' }}>
                    <Component {...props} {...context} />
                      {host && host.includes('avaliamt') ? (
                      <>
                        {href && (
                          href.includes('personal') ||
                          href.includes('report-plan')
                         ) && (
                          <WhatsappSupport />
                        )}
                        <LoadAssistent />
                      </>
                    ) : (
                      <ThemeContext.Consumer>
                        {(theme) => (
                          <div>
                            {!iframe && <SesiSupportBtn />}
                            {/* <LoadAssistent /> */}
                          </div>
                        )}
                      </ThemeContext.Consumer>
                    )}
                  </div>
                  {(footer && !iframe) && <Footer />}
                </React.Fragment>
              );
            }}
          </UserContext.Consumer>
        ) : (
          <Redirect to="/login" />
        )
      }
    />
  </div>
);

PrivateRoute.propTypes = {
  component: PropTypes.func.isRequired,
  navbar: PropTypes.bool,
  footer: PropTypes.bool,
  permission: PropTypes.string,
  allowedGroups: PropTypes.array
};

PrivateRoute.defaultProps = {
  navbar: true,
  footer: true,
  permission: '',
  allowedGroups: [
    'Rede de Ensino',
    'Diretoria Regional',
    'Diretor da Escola',
    'Coordenador',
    'Professor',
    'Aluno',
    ''
  ]
};

export default PrivateRoute;
